import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
const _clone = (d) => JSON.parse(JSON.stringify(d));
import { Validators, FormControl } from "@angular/forms";
import * as XLSX from 'xlsx';
import { TransactionService } from 'src/app/services/transaction/transaction.service';
import { PayoutService } from 'src/app/services/payout.service';
const swal = require('sweetalert');
@Component({
  selector: 'app-manage-payout-security-transactions',
  templateUrl: './manage-payout-security-transactions.component.html',
  styleUrls: ['./manage-payout-security-transactions.component.scss']
})
export class ManagePayoutSecurityTransactionsComponent implements OnInit {
  MerchantKeyId:any;
  TransactionRows=[];
  checkLoginResellerId:any;
  rows=[];
  isreportsbtnActive: boolean = false;
  paymentStatus:any;
  fromdate1: any;
  todate1: any;
  daterange = new FormControl("", [Validators.required]);
  bankname = new FormControl("", [Validators.required]);
  AccountNumber= new FormControl("", [Validators.required]);
  fromdate = new FormControl("", [Validators.required]);
  todate = new FormControl("", [Validators.required]);
  Dfiltering: boolean = true;
  Rfromdate: boolean = false;
  isStartDateGreaterthenEndDate: boolean = false;
  isCustomDateSelected: boolean = false;
  TransactionId= new FormControl("", []);
  merchantKeyId= new FormControl("", []);
  MobileNumber= new FormControl("", []);
  IFSCCode= new FormControl("", []);
  filtering: boolean = false;
  excelTansactionDataResponse = [];
  temp = [];
  rowsFilter = [];
  rowsExp = [];
  rowsSort = [];
  rowsSel = [];
  dataList: any[];
  Range = [
    { text: "Today", value: "0" },
    { text: "Yesterday", value: "2" },
    { text: "current week", value: "4" },
    { text: "Last Week", value: "1" },
    { text: "This Month", value: "1" },
    { text: "Last Month", value: "2" },
    { text: "Custom Date Range", value: "4" }
  ];
  constructor(private commonfunction: CommonFunctionService, private transactionservice: TransactionService,private service:PayoutService) { }

  ngOnInit() {
    this.GetPayoutSecurityTransactions();
  }
  GetPayoutSecurityTransactions() {
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  this.MerchantKeyId = merchantdata.MerchantKeyId;
  
  this.service.GetPayoutSecurityTransactions(this.MerchantKeyId).subscribe(result => { 
    if(result!=null){
      this.TransactionRows=_clone(result);;
      this.TransactionRows.forEach(element => {
        if (element.AccountNumber !=null) {
        var first6digits = element.AccountNumber.slice(0, 6);
       var last4digits = element.AccountNumber.slice(-4);
          element.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
        }
       
      });
    }
  });
  }
  ResendEmail(details){
    this.service.ResendPayoutCustomerSecurity(details.Email,details.MerchantKeyId,details.TransactionId).subscribe(result => { 
      if(result!=null){
        swal("Sent", "Email has been sent successfully", "success");  
      }
    });
   }
   ResendSms(details){
    this.service.ResendPayoutCustomerSecuritysms(details.MobileNumber,details.MerchantKeyId,details.TransactionId).subscribe(result => { 
      if(result!=null){
        swal("Sent", "Message has been sent successfully", "success");  
      }
    });
   }
   filters() {
    //   this.filtering=true;
    this.filtering = !this.filtering;
  }
  
  
  selectedaterange() {
    var daterange = this.daterange.value;
    if (daterange == "Custom Date Range") {
      this.isCustomDateSelected = true;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = true;
      this.Dfiltering = false;
    }
    else {
      this.isCustomDateSelected = false;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = false;
      this.search();
  
    }
  }
  search() {
    this.Getpayouttrasactionsfilter((data) => {
      // cache our list
    
    });
  }
  
  
  Getpayouttrasactionsfilter(cb) {
    var daterange = this.daterange.value;
   // var Status = this.Status.value;
    var Tid = this.TransactionId.value;
    var merchantKeyId = this.merchantKeyId.value;
    var BankName=this.bankname.value;
    var AccountNumber=this.AccountNumber.value;
    var IFSCCode=this.IFSCCode.value;
    var MobileNumber=this.MobileNumber.value;
    if (merchantKeyId == "") {
      merchantKeyId = "0";
    }
    if (Tid == "") {
      Tid = "0";
    }
    if (daterange == "Today") {
      this.fromdate1 = new Date().toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);
    }
    else if (daterange == "Yesterday") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDate() - 1)).toISOString().slice(0, 10);
      this.fromdate1 = tomorrow;
      this.todate1 = tomorrow;
  
    }
    else if (daterange == "current week") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDay()));
  
  
      var current = new Date();
      var weekstart = current.getDate() - current.getDay() + 1;
      var weekend = weekstart + 6;
      this.fromdate1 = new Date(current.setDate(weekstart)).toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);
  
    }
    else if (daterange == "Last Week") {
      var curr = new Date;
      var first = curr.getDate() - curr.getDay() - 6;
      var last = first + 6;
      this.fromdate1 = new Date(curr.setDate(first)).toISOString().slice(0, 10);
      this.todate1 = new Date(curr.setDate(last)).toISOString().slice(0, 10);
  
  
    }
    else if (daterange == "This Month") {
      const today = new Date();
      // const thismonth = new Date(today.setDate(today.getMonth())).toISOString().slice(0, 10);
      //this.Fromdate1=thismonth;   
      this.fromdate1 = new Date(today.getFullYear(), today.getMonth(), 1).toDateString();
      this.todate1 = new Date().toISOString().slice(0, 10);
  
    }
    else if (daterange == "Last Month") {
      // var date = new Date();                
      // this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString().slice(0,10);
      // this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toISOString().slice(0,10);
      var date = new Date();
      this.fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toDateString();
      this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toDateString();
  
  
    }
    else if (daterange == "Custom Date Range") {
  
      this.fromdate1 = this.fromdate.value;
      this.todate1 = this.todate.value;
    }
    else {
      this.fromdate1 = new Date().toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);
    }
  

    this.service.GetFilteredPayoutSecurityTransactionUrl(this.MerchantKeyId,this.fromdate1,this.todate1,Tid,AccountNumber,IFSCCode).subscribe(data => {
    if(data !=null)
    {
      this.temp = _clone(data);
      this.TransactionRows = _clone(data);;
      this.rowsFilter = _clone(data);;
      this.rowsExp = _clone(data);
      this.rowsSort = _clone(data);
      this.rowsSel = _clone(data);
  
      this.TransactionRows.forEach(element => {
        if (element.AccountNumber !=null) {
        var first6digits = element.AccountNumber.slice(0, 6);
       var last4digits = element.AccountNumber.slice(-4);
          element.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
        }
       
      });
  
  
    }
  });
    // const req = new XMLHttpRequest();
    // req.open('GET',
    //   environment.GetFilteredPayoutSecurityTransactionUrl + "?MerchantKeyId=" +  this.MerchantKeyId +
    //   "&fromdate=" + this.fromdate1 + "&todate=" + this.todate1+ "&TransactionId=" + Tid
      
    //    + "&Accnumber=" + AccountNumber+"&IFSCCode="+ IFSCCode);
    //  req.onload = () => {
    //   cb(JSON.parse(req.response));
    // };
  
    // req.send();
  }
  
  
  checkDateRange() {
    if (this.fromdate.value != "" && this.todate.value != "") {
      if (this.fromdate.value > this.todate.value) {
        this.isreportsbtnActive = false;
        this.isStartDateGreaterthenEndDate = true;
      }
      else {
        this.isreportsbtnActive = true;
        this.isStartDateGreaterthenEndDate = false;
      }
    }
    else {
      this.isreportsbtnActive = false;
      this.isStartDateGreaterthenEndDate = false;
    }
  }
  checkRangeType() {
    var daterange = this.daterange.value;
    if (daterange == "Custom Date Range") {
      this.isCustomDateSelected = true;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = true;
      this.Dfiltering = false;
      this.fromdate.setValue('');
      this.todate.setValue('');
      this.isreportsbtnActive = false;
    }
    else {
      this.isCustomDateSelected = false;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = false;
    }
  }
  
}
